import React from "react";

const NAVY = "#0B1F3A";
const GOLD = "#D4AF37";

/**
 * BEE Exsellance "X" mark — two interlocking diagonals (navy "\" + gold "/")
 * forming a confident X, inspired by the client's reference.
 */
export function XMark({ size = 44, onDark = false, id = "xm" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="BEE Exsellance X mark">
      <defs>
        <linearGradient id={`${id}-navy`} x1="16" y1="8" x2="84" y2="92" gradientUnits="userSpaceOnUse">
          <stop stopColor={onDark ? "#FFFFFF" : "#16305c"} />
          <stop offset="1" stopColor={onDark ? "#DCE3EE" : NAVY} />
        </linearGradient>
        <linearGradient id={`${id}-gold`} x1="84" y1="8" x2="16" y2="92" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E7C868" />
          <stop offset="1" stopColor={GOLD} />
        </linearGradient>
      </defs>
      {/* gold "/" diagonal (behind) */}
      <polygon points="60,7 85,7 40,93 15,93" fill={`url(#${id}-gold)`} />
      {/* navy "\" diagonal (front) */}
      <polygon points="15,7 40,7 85,93 60,93" fill={`url(#${id}-navy)`} />
      {/* small gold tip re-drawn on top for a woven look (bottom-left) */}
      <polygon points="15,93 40,93 31,76 21,76" fill={`url(#${id}-gold)`} />
      {/* small gold tip top-right woven */}
      <polygon points="60,7 85,7 79,24 69,24" fill={`url(#${id}-gold)`} />
    </svg>
  );
}

/**
 * Horizontal logo lockup: X mark + "BEE EXSELLANCE" wordmark + slogan.
 * variant: "dark" (light backgrounds) | "light" (dark backgrounds)
 */
export default function Logo({ variant = "dark", size = 42, showSlogan = true, className = "" }) {
  const onDark = variant === "light";
  const name = onDark ? "#FFFFFF" : NAVY;
  const rest = onDark ? "#EAEDF3" : "#2E2E2E";
  const sloganColor = onDark ? "#C9D2E2" : NAVY;
  const mark = onDark ? "/logo-real-light.png" : "/logo-real.png";

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img src={mark} alt="BEE Exsellance" style={{ height: size, width: "auto" }} className="object-contain" />
      <span className="leading-none">
        <span
          className="block font-head font-extrabold uppercase"
          style={{ fontSize: size * 0.46, letterSpacing: "0.06em", color: name }}
        >
          BEE E<span style={{ color: GOLD }}>X</span><span style={{ color: rest }}>SELLANCE</span>
        </span>
        {showSlogan && (
          <span className="flex items-center gap-1.5 mt-[5px]">
            <span style={{ height: 1.4, width: 14, background: GOLD }} />
            <span
              className="font-head font-semibold uppercase whitespace-nowrap"
              style={{ fontSize: size * 0.2, letterSpacing: "0.2em", color: sloganColor }}
            >
              Your B-BBEE Advisor
            </span>
            <span style={{ height: 1.4, width: 14, background: GOLD }} />
          </span>
        )}
      </span>
    </span>
  );
}
